import { UpdateStoreRequest } from '@fiverr-private/store_builder_types';
import pathfinder from '@fiverr-private/pathfinder';
import { logger } from '@fiverr-private/obs';
import { type CustomAxiosConfig, maxios } from '../../lib/maxios/maxios';
import { handleApiError } from '../utils/handle-api-error/handleApiError';

export const verifyStoreLink = async (storeId: string, storeUrl: UpdateStoreRequest): Promise<boolean> => {
    const url = pathfinder('ai_store_builder_api_put', {
        version: 'v1',
        store_id: storeId,
    });

    const options: Partial<CustomAxiosConfig> = {
        routeKey: 'verify_store_link',
    };

    try {
        const response = await maxios.put(url, storeUrl, options);
        return response.status === 200;
    } catch (error) {
        logger.error(error as Error, {
            description: 'Failed to check store link',
            store_id: storeId,
            store_url: storeUrl,
        });

        throw handleApiError(error);
    }
};
